module.exports = __webpack_public_path__ + "static/media/MIAB9983-180731-143_Small.bc41cebb.jpg";